export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy and security.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access our extensive network of high-performance servers located across the globe, ensuring fast and reliable connections wherever you are in the world.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Lightning Fast Speed',
      description: 'Experience blazing-fast connection speeds with our optimized infrastructure. Stream, browse, and download without compromising on performance or security.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h3 className="text-5xl font-bold text-gray-900 mb-20">
          Why Choose Our VPN
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-14 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
            >
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-teal-400 to-cyan-600 flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-white text-3xl`}></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-5">
                {feature.title}
              </h4>
              <p className="text-base text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
